import { createEnvelopeSource } from './create-envelope-source';

export const totalUsersSource = createEnvelopeSource({
    label: 'Total users',
    endpoint: 'analytics/total-users',
    metrics: [{ id: 'totalUsers', label: 'Total users', type: 'scalar' }],
    forms: ['number'],
    regionGrain: 'province',
});
